import { Outlet } from 'react-router-dom';
// import {WebSocketProvider} from './Utils/WebSocketContext'
import WebSocketProvider from "./WebSocketContext"

const WebSocketRouteWrapper = () => {
    return (
      <WebSocketProvider>
        <Outlet />
      </WebSocketProvider>
    );
  };



  export default WebSocketRouteWrapper;